import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMetrodeparisComponent } from './simple-icons-metrodeparis.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMetrodeparisComponent ],
    exports:      [ SimpleIconsMetrodeparisComponent ],
    bootstrap:    []
})
export class SimpleIconsMetrodeparisModule {}
